import { Component, inject, signal } from "@angular/core";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { derivedAsync } from "ngxtension/derived-async";
import { Skeleton } from "primeng/skeleton";
import { catchError, of } from "rxjs";
import { AppDatePipe } from "../../../shared/pipes/date.pipe";
import { SettingsService } from "../../../shared/services/settings.service";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiDashboardCardHeaderComponent } from "../layout/new-ui-dashboard-card-header/new-ui-dashboard-card-header.component";
import { NewUiDashboardCardComponent } from "../layout/new-ui-dashboard-card/new-ui-dashboard-card.component";
import { NewUiDashboardService } from "../new-ui-dashboard.service";

@Component({
  selector: "new-ui-dashboard-release-notes-notes",
  templateUrl: "./new-ui-dashboard-release-notes.component.html",
  imports: [
    NewUiDashboardCardHeaderComponent,
    NewUiDashboardCardComponent,
    TranslateDirective,
    AppDatePipe,
    Skeleton,
    NewUiButton,
  ],
})
export class NewUiDashboardReleaseNotesComponent {
  private readonly dashboardService = inject(NewUiDashboardService);
  private readonly settings = inject(SettingsService);

  protected readonly ankaadiaUpdate = derivedAsync(() =>
    this.dashboardService.getAnkaadiaUpdate().pipe(catchError(() => of(null)))
  );

  protected readonly isLicensed = signal(this.settings.isLicensed);

  protected openRoadmap(): void {
    window.open(
      "https://roadmap.ankaadia.com/roadmap?roadmap=roadmap_01m1eh5aaqfvgbzkbj1685s4hw",
      "_blank",
      "noopener,noreferrer"
    );
  }
}
